import CustomButton from "./Base/CustomButton";
import Modal from "./Modal";
export default function InValidAccess({ isShow, clickHandler }) {
  return (
    <div className="session-model">
      <Modal
        isOpen={isShow}
        title={"Access Denied"}
        cstmClassName={"session-custom-model"}
        onClose={clickHandler}
      >
        <div className="session-wrap">
          <div>Sorry, you do not have permission to view this page.</div>
          <div>
            <CustomButton buttonHandler={clickHandler} label={"OK"} />
          </div>
        </div>
      </Modal>
    </div>
  );
}
